import { api } from '../api';

export const lockerService = {
  list: () => api.get('/lockers'),
  get: (id: string) => api.get(`/lockers/${id}`),
  create: (data: any) => api.post('/lockers', data),
  update: (id: string, data: any) => api.patch(`/lockers/${id}`, data),
  remove: (id: string) => api.delete(`/lockers/${id}`),
  createReservation: (data: any) => api.post('/reservations', data),
};